module.exports = __webpack_public_path__ + "media/images/logo_prodos-d5b5a50c35e756e939d8d81bbea181de.jpg";